const UNITS = 'KB MB GB TB PB EB ZB YB'.split(' ');
const THRESHOLD = 1e3;

/**
 * Converts provided bytes into appropriate data format.
 * @returns DataArray
 * @DataArray [0] formatted string representing conversion value
 * @DataArray [1] string representing conversion unit
 */
export function getDataSize(bytes: number, decimals = 1, usePlusSign = false) {
  const isNegative = Math.sign(bytes) === -1;
  let num = Math.abs(bytes);
  let index = 0;

  while (num >= THRESHOLD && ++index < UNITS.length) {
    num /= THRESHOLD;
  }

  const formattedNum = index === 0 ? num.toString() : num % 1 === 0 ? num : num.toFixed(decimals);

  const unit = index === 0 ? 'Bytes' : UNITS[index - 1];

  return [isNegative ? `-${formattedNum}` : num > 0 && usePlusSign ? `+${formattedNum}` : formattedNum, unit];
}
